'use client';

import { useEffect, useRef, useState, type CSSProperties } from 'react';
import { CONTACT_EMAIL } from '@/lib/config';
import { REVEAL_CHARSET, scrambleTextOneShot } from '@/lib/textEffects/scramble';

const HOVER_REVEAL_MS = 1000;
const HOVER_FRAME_MS = 65;

interface Props {
  fontSize: number;
  style?: CSSProperties;
}

export default function ContactButton({ fontSize, style }: Props) {
  const [hovered, setHovered] = useState(false);
  const hoverTextRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = hoverTextRef.current;
    if (!hovered || !el) return;
    return scrambleTextOneShot(el, {
      durationMs: HOVER_REVEAL_MS,
      frameMs: HOVER_FRAME_MS,
      charset: REVEAL_CHARSET,
      revealLeftToRight: true,
    });
  }, [hovered]);

  const openMail = () => {
    window.location.href = `mailto:${CONTACT_EMAIL}`;
  };

  return (
    <button
      type='button'
      className='button-right'
      onClick={openMail}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ fontSize, fontWeight: 700, ...style }}
    >
      {hovered
        ? <span ref={hoverTextRef}>LET&apos;S CREATE CHEMISTRY</span>
        : <span className='letter-scrambler'>{CONTACT_EMAIL}</span>}
    </button>
  );
}
